/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
// libraries
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
// utils
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { FaFacebook, FaInstagram, FaPhoneAlt, FaTwitter, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { IconFacebook, IconInstagram, IconTelephone, IconThreads, IconTiktok, IconTwitter, IconWhatsapp, IconYoutube } from '../../../../../../assets';
import { useSiteRegiao } from '../../../../../../components/context/Info';
import DrawerComponent from '../../../../../../components/drawer/DrawerComponent';
import { trackLead } from '../../../../../../components/whatsAppButton/WhatsAppButton';
import { resolveSiteWhatsAppUrl } from '../../../../../../utils/site2524WhatsApp';
import { isColorLight, MaskPhone } from '../../../../../../utils/FunctionsGlobals';
import { escalaLogoCrm } from '../../../../../../utils/logoTenant';
import { appendCodsiteQuery } from '../../../../../../utils/url';
import styles from './WelcomePiecesProperties.module.css';
const Topo2 = dynamic(() => import('../../../../../../components/pieces/topo2/Topo'), { ssr: true });
import { NEW_TOPO } from '../../../../../../components/registry/home';
import { topoDaHomeNasInternas } from '../../../../../../utils/topoHomeNasInternas';
import { corIconeMenu } from '../../../../../../components/shared/menu-icon/corIconeMenu';
import { corIconeTelefoneTopo, mostraTerceiroTelefoneNoTopo, mostraWhatsELigarNoCelular, numerosDoTopoEmNegrito, numeroDoTopoEmUmaLinha, topoFixoAoRolar } from '../../../../../../utils/topoContato';
import WhatsELigarCelular from '../../../../../../components/pieces/topo/WhatsELigarCelular';
import { temSeletorIdiomas } from '../../../../../../utils/idiomaMoedaSite';
import { IdiomaNavItem } from '../../../../../../components/pieces/idiomas/menu';

const WelcomePiecesProperties2: React.FC<{
    site: any;
    favorito: Array<number>;
    props: any;
}> = ({ site: siteProp, favorito, props }) => {
    // MULTI-REGIÃO: contatos (tel1/tel2/email1) trocados pelos da região ativa quando houver
    const site = useSiteRegiao(siteProp);
    // REGISTRY (M1): variante nova de topo entra ANTES do ternário legado do
    // header — mesmo mapa da home (chave = modelo_topo). Vazio ⇒ undefined ⇒ topo
    // de sempre (zero diff). Sem este ponto, um topo novo só apareceria na home.
    // cs2586: opção "topo da home nas internas" (topos 5/6/7) — ver utils/topoHomeNasInternas.
    const TopoDaHome = NEW_TOPO[Number(site?.modelo_topo)] ? undefined : topoDaHomeNasInternas(site);
    const TopoNovo = NEW_TOPO[Number(site?.modelo_topo)] ?? TopoDaHome;
    // constants
    const router = useRouter();
    // HEX DO CRM VEM EM QUALQUER CAIXA: o CRM grava "#FFFFFF" ou "#ffffff" conforme a tela
    // que salvou. A comparação abaixo era estrita, então quem tinha o branco em MAIÚSCULA
    // escapava da regra "cor1 branco ⇒ barra do topo usa a cor3" e caía no fallback final
    // (cor_fundo = cor1 = branco ⇒ cor_texto = cor11 = escuro). Era o caso do cs2606: barra
    // branca com telefone/rótulos pretos, enquanto no resto do site as letras são brancas.
    // Normalizar a caixa alinha esses tenants aos outros ~183 que já usam a cor3.
    const cor1Hex = String(site?.cor1 ?? '').toLowerCase();
    const cor3Hex = String(site?.cor3 ?? '').toLowerCase();
    // 2600: barra clara (cor1, igual ao topo da home) em vez do fallback cinza #7a7a7a p/ cor1+cor3 brancas
    const cor_fundo = site?.id == 2600 ? site?.cor1 : site?.id == 2443 ? "#000000" : site?.id == 2422 || site?.id == 2445 ? site?.cor10 : site?.modelo_topo == 3 || site?.id == 2378 ? site?.cor1 : site?.id == 1890 ? "#f5f5f5" : site?.id == 2315 ? "#1c4256"  : site?.id == 2237 ? "#8b8d91"  : site?.id == 1630 ? site?.cor3 : cor1Hex == "#ffffff" && !site?.navbar_transparente && site?.id != 2311 ? cor3Hex == "#ffffff" ? "#7a7a7a" : site?.cor3 : site?.id == 2030 ? "#0000008f" : site?.cor1
    const cor_texto = isColorLight(cor_fundo) ? site?.cor11 : site?.cor13;
    // LOGO POR TENANT (allowlist LOGO_SEGUE_TAMANHO_CRM em utils/logoTenant.ts): a página do
    // imóvel tem base própria de 100px — escala junto com o tamanho_logo do CRM, como o topo.
    const escalaLogo = escalaLogoCrm(site);
    const logoImovelHeight = escalaLogo ? Math.round(100 * escalaLogo) : null;
    const classeLogoCrm = logoImovelHeight ? ` ${styles.logo_crm}` : '';
    const withCodsite = (href: string) => appendCodsiteQuery(href, router.query?.codsite);
    const isSite2532 = Number(site?.id) === 2532; // 2532: topo do imóvel exibe SÓ o comercial (tel2), igual à home (Topo.tsx)
    // cs2639 (utils/topoContato): topo preso no alto ao rolar e ícone do telefone fixo na cor da marca
    const classeTopoFixo = topoFixoAoRolar(site) ? ` ${styles.topo_fixo}` : '';
    // topo da home nas internas: a altura vem do espaçador do próprio topo (Editorial = 116px), não dos 100px fixos
    const classeTopoDaHome = TopoDaHome ? ` ${styles.oneStepTopoDaHome}` : '';
    const corTelefoneTopo = corIconeTelefoneTopo(site);
    // número de telefone em negrito, rótulo no peso normal (utils/topoContato, cs2639)
    const classeContatoBase = numerosDoTopoEmNegrito(site) ? `${styles.columnContato} ${styles.numero_negrito}` : styles.columnContato;
    // cs2644: número em uma linha só (ver utils/topoContato.ts)
    const classeContato = numeroDoTopoEmUmaLinha(site) ? `${classeContatoBase} ${styles.numero_uma_linha}` : classeContatoBase;

    // useState
    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const [vips, setVips] = useState<any>("");

    useEffect(() => {
        if(!vips){
            const vip: any = localStorage.getItem('vip');
            if(vip){
                setVips(vip)
            }
        }
    }, [vips]);

    // methods
    const openDrawer = () => {
        setActiveDrawer(true);
    };

    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: IconInstagram,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.threads || '',
            id: 6,
            icon: IconThreads,
            rede: 'Threads'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: IconFacebook,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: IconTwitter,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: IconTiktok,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: IconYoutube,
            rede: 'Youtube'
        },
    ];

    const renderText = () => {
        if (site?.id) {
            if(site?.texto_botao_whats){
                return `${site?.texto_botao_whats}`;
            }
            return `Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`;
        }
        return 'Olá, estou visitando o site, gostaria de um atendimento personalizado. Pode me ajudar?';
    };

    return (
        <div className={`${site?.modelo_topo == 3 && site?.id == 2379 ? styles.oneStep1 : styles.oneStep}${classeLogoCrm}${classeTopoFixo}${classeTopoDaHome}`} style={{...(site?.modelo_topo == 3 && site?.id == 2379 ? {background: cor_fundo} : site?.modelo_topo == 3 ? {background: cor_fundo, maxHeight: 80} : {}), ...(logoImovelHeight ? {'--logo-h-imovel': `${logoImovelHeight}px`} : {})} as React.CSSProperties}>
            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                vips={vips}
                menus={props?.menus}
            />
            {TopoNovo ?
                <TopoNovo site={site} setActiveDrawer={setActiveDrawer} setBuscaAvancada={null}/>
            : site?.modelo_topo == 3 ?
                <Topo2 site={site} setActiveDrawer={setActiveDrawer} setBuscaAvancada={null}/>
            :
            <div className={styles.header_welcome} data-el="welcome-header" style={{background: cor_fundo}}>
                <div className={styles.header_main} style={site?.id == 2030 ? { background: '#0000008f' } : {}}>
                    <Link href={withCodsite('/')} prefetch={false}>
                        {(
                            site?.id == "2434"
                                ? "https://imob.sobressai.com.br/Banner/2434/11945.jpg"
                                : site?.id == "2258"
                                ? "https://fotos.sobressai.com.br/Banner/2258/11487.jpg"
                                : site?.id == "2245"
                                ? "https://fotos.sobressai.com.br/Banner/2245/11400.jpg"
                                : site?.id == 2259
                                ? "https://fotos.sobressai.com.br/Banner/2259/11399.jpg"
                                : `${site?.url_logo}?v=${site?.contador_marca || 0}`
                        ) ? (
                            <Image
                                src={
                                    site?.id == "2434"
                                        ? "https://imob.sobressai.com.br/Banner/2434/11945.jpg"
                                        : site?.id == "2258"
                                        ? "https://fotos.sobressai.com.br/Banner/2258/11487.jpg"
                                        : site?.id == "2245"
                                        ? "https://fotos.sobressai.com.br/Banner/2245/11400.jpg"
                                        : site?.id == 2259
                                        ? "https://fotos.sobressai.com.br/Banner/2259/11399.jpg"
                                        : `${site?.url_logo}?v=${site?.contador_marca || 0}`
                                }
                                style={site?.id == 1630 ? {height: 100, width: "auto",objectPosition: "left",padding: 0} : site?.tamanho_logo > 1 ? {height: site?.tamanho_logo} : {}}
                                alt={`Imobiliária ${site?.Dados?.empresa}`}
                                title={`Imobiliária ${site?.Dados?.empresa}`}
                                className={styles.logo_welcome}
                                width={340}
                                height={100}
                                sizes="(max-width: 768px) 200px, 340px"
                            />
                        ) : null}
                    </Link>
                    {/* 22/10 (rodada 2): no celular o grupo da direita é estreito (10%) — o idioma (só a bandeira) entra
                        antes dele, colado ao ☰ */}
                    {temSeletorIdiomas(site) ? (
                        <IdiomaNavItem ocultarAcima={768} compacto estilo={{ color: corIconeMenu(site, cor_texto), marginLeft: 'auto', marginRight: 6 }} />
                    ) : null}
                    {/* Nesta cópia do topo o telefone só some até 768px (no Topo.tsx são 850px) */}
                    {mostraWhatsELigarNoCelular(site) ? (
                        <WhatsELigarCelular
                            site={site}
                            urlWhatsapp={resolveSiteWhatsAppUrl(site, `https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`)}
                            cor={corIconeMenu(site, cor_texto)}
                            posicao="linha"
                        />
                    ) : null}
                    <div className={styles.flex}>
                        {site?.id == "2133" &&
                            <div className={styles.texto_centro}>
                                <a
                                    className={styles.btn}
                                    style={{
                                        background: `${site?.cor2 || 'rgb(30 30 30)'}`,
                                        border: `1px solid ${site?.cor2 || '#FFFFFF'}`,
                                        color: site?.cor4
                                    }}
                                    href="https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link" target="_blank" rel="noreferrer">
                                    Anuncie
                                </a>
                            </div>
                        }
                        {site?.Dados?.tel1 && !isSite2532 && site?.id != "2042" && site?.id != "1946" && site?.id != "2057" && site?.id != "2102" ?
                            <a
                                className={styles.flex1}
                                rel="noopener noreferrer"
                                href={site?.Dados?.tel1_whats ? resolveSiteWhatsAppUrl(site, (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`)): site?.id == "1937" ? `tel:${(site?.Dados?.tel1)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel1)?.replace(/\D/g, '')}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.Dados?.tel1_whats ? resolveSiteWhatsAppUrl(site, (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel1)?.replace(/\D/g, '')}&text=${renderText()}`)): site?.id == "1937" ? `tel:${(site?.Dados?.tel1)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel1)?.replace(/\D/g, '')}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                            >
                                {site?.id == 2259 || site?.id == 1630 || site?.id == 2347 || site?.id == 2331 || site?.id == 2470 || site?.id == 2471 ?
                                    <FaWhatsapp fill='black' style={{display: "flex",alignItems: "center",fontSize: 24,fill: 'white'}}/>
                                :
                                corTelefoneTopo && !site?.Dados?.tel1_whats ?
                                    <FaPhoneAlt aria-label="Telefone" title="Icone Telefone 1" style={{fontSize: 20, color: corTelefoneTopo, flexShrink: 0}} />
                                :
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 1"
                                    title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 1' : 'Icone Telefone 1'}
                                    src={site?.Dados?.tel1_whats ? IconWhatsapp : IconTelephone}
                                />
                                }
                                <div className={classeContato} style={{color: cor_texto}}>
                                    {site?.id == "1937" ? site?.Dados?.tel1 : MaskPhone(
                                        site?.Dados?.tel1
                                    )}
                                    <div className={styles.type_number} style={{color: cor_texto}}>
                                        {site?.Dados?.tel1_nome ? site?.Dados?.tel1_nome : "WhatsApp"}
                                    </div>
                                </div>
                            </a>
                        :null}
                        {site?.Dados?.tel2 && site?.id != "2042" && site?.id != "1946" && site?.id != "2057" && site?.id != "2102" && site?.id != "2288" ?
                            <a
                                className={styles.flex1}
                                rel="noopener noreferrer"
                                href={site?.Dados?.tel2_whats ? resolveSiteWhatsAppUrl(site, (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel2)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel2)?.replace(/\D/g, '')}&text=${renderText()}`)): site?.id == "1937" ? `tel:${(site?.Dados?.tel2)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel2)?.replace(/\D/g, '')}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.Dados?.tel2_whats ? resolveSiteWhatsAppUrl(site, (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel2)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel2)?.replace(/\D/g, '')}&text=${renderText()}`)): site?.id == "1937" ? `tel:${(site?.Dados?.tel2)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel2)?.replace(/\D/g, '')}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                            >
                                {site?.id == 2259 ?
                                    <FaWhatsapp fill='black' style={{display: "flex",alignItems: "center",fontSize: 24,fill: 'white'}}/>
                                :
                                corTelefoneTopo && !site?.Dados?.tel2_whats ?
                                    <FaPhoneAlt aria-label="Telefone" title="Icone Telefone 2" style={{fontSize: 20, color: corTelefoneTopo, flexShrink: 0}} />
                                :
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 2"
                                    title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 2' : 'Icone Telefone 2'}
                                    src={site?.Dados?.tel2_whats ? IconWhatsapp : IconTelephone}
                                />}
                                <div className={classeContato} style={{color: cor_texto}}>
                                    {site?.id == "1937" ? site?.Dados?.tel2 : MaskPhone(
                                            site?.Dados?.tel2
                                    )}
                                    <div className={styles.type_number} style={{color: cor_texto}}>
                                        {site?.Dados?.tel2_nome ? site?.Dados?.tel2_nome : "Comercial"}
                                    </div>
                                </div>
                            </a>
                        :null}
                        {mostraTerceiroTelefoneNoTopo(site) && site?.Dados?.tel3 ?
                            <a
                                className={styles.flex1}
                                rel="noopener noreferrer"
                                href={site?.Dados?.tel3_whats ? resolveSiteWhatsAppUrl(site, (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel3)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel3)?.replace(/\D/g, '')}&text=${renderText()}`)): site?.id == "1937" ? `tel:${(site?.Dados?.tel3)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel3)?.replace(/\D/g, '')}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // Registra o evento Lead

                                    // Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.Dados?.tel3_whats ? resolveSiteWhatsAppUrl(site, (site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(site?.Dados?.tel3)?.replace(/\D/g, '')}&text=${renderText()}`:`https://api.whatsapp.com/send?phone=55${(site?.Dados?.tel3)?.replace(/\D/g, '')}&text=${renderText()}`)): site?.id == "1937" ? `tel:${(site?.Dados?.tel3)?.replace(/\D/g, '')}` : `tel:+55${(site?.Dados?.tel3)?.replace(/\D/g, '')}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                            >
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 3"
                                    title={site?.Dados?.tel3_whats ? 'Icone WhatsApp 3' : 'Icone Telefone 3'}
                                    src={site?.Dados?.tel3_whats ? IconWhatsapp : IconTelephone}
                                />
                                <div className={classeContato} style={{color: cor_texto}}>
                                    {site?.id == "1937" ? site?.Dados?.tel3 : MaskPhone(
                                            site?.Dados?.tel3
                                    )}
                                    <div className={styles.type_number} style={{color: cor_texto}}>
                                        {site?.Dados?.tel3_nome ? site?.Dados?.tel3_nome : "Comercial"}
                                    </div>
                                </div>
                            </a>
                        :null}
                        {site?.id == 2473 ?
                            <a
                                className={styles.flex1}
                                rel="noopener noreferrer"
                                href={`https://api.whatsapp.com/send?phone=+5511941271805&text=${renderText()}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        `https://api.whatsapp.com/send?phone=+5511941271805}&text=${renderText()}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                            >
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 2"
                                    title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 2' : 'Icone Telefone 2'}
                                    src={site?.Dados?.tel2_whats ? IconWhatsapp : IconTelephone}
                                />
                                <div className={classeContato} style={{color: cor_texto}}>
                                    (11) 94127-1805
                                    <div className={styles.type_number} style={{color: cor_texto}}>
                                        Carlos Munhoz
                                    </div>
                                </div>
                            </a>
                        :null}
                        {site?.id == 1825 ?
                            <a
                                className={styles.flex1}
                                rel="noopener noreferrer"
                                href={`https://api.whatsapp.com/send?phone=+5547991389248}&text=${renderText()}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        `https://api.whatsapp.com/send?phone=+5547991389248}&text=${renderText()}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                            >
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 2"
                                    title={site?.Dados?.tel1_whats ? 'Icone WhatsApp 2' : 'Icone Telefone 2'}
                                    src={site?.Dados?.tel2_whats ? IconWhatsapp : IconTelephone}
                                />
                                <div className={classeContato} style={{color: cor_texto}}>
                                    (47) 99138-9248
                                    <div className={styles.type_number} style={{color: cor_texto}}>
                                        Locação
                                    </div>
                                </div>
                            </a>
                        :null}
                        {site?.id == 2033 && 
                            <a className={styles.blog} href="https://appmoradaimoveisrs.com.br/morada" data-no-quicklink    
                                data-no-instant      
                                data-no-prefetch   
                                title="Área do Cliente"
                                target='_blank'  
                                rel="noopener noreferrer">
                                Área do Cliente
                            </a>
                        }
                        {site?.redes_topo &&
                            <>
                            {site?.id == "1836" &&
                                <a className={styles.blog} href="https://antigo.estilogramadoimoveis.com.br/blog" data-no-quicklink    
                                data-no-instant      
                                data-no-prefetch     
                                rel="nofollow">
                                    Blog
                                </a>
                            }
                            <div className={styles.redes_sociais}>
                                <div className={styles.container1} style={{display: 'flex'}}>
                                    {allSocials?.map((v) => {
                                        if (v) {
                                            if (v.href) {
                                                return (
                                                    <a
                                                        aria-label={v.href}
                                                        rel="noopener noreferrer"
                                                        target="_blank"
                                                        href={v.href}
                                                        key={v.id}
                                                        title={`Navegar para o ${v.rede} da imobiliária`}
                                                        className={styles.adjust_img1}
                                                    >
                                                        {site?.id == 2259 || site?.id == 2471 ?
                                                            v?.id == 3 ? <FaInstagram fill='black' style={{display: "flex",alignItems: "center",fontSize: 24,fill: 'white'}}/> :
                                                            v?.id == 1 ? <FaFacebook fill='black' style={{display: "flex",alignItems: "center",fontSize: 24,fill: 'white'}}/> :
                                                            v?.id == 2 ? <FaYoutube fill='black' style={{display: "flex",alignItems: "center",fontSize: 24,fill: 'white'}}/> :
                                                            v?.id == 4 ? <FaTwitter fill='black' style={{display: "flex",alignItems: "center",fontSize: 24,fill: 'white'}}/> :
                                                            <Image
                                                                alt={`Imagem rede social ${v.rede}`}
                                                                src={v.icon}
                                                                height={37}
                                                                width={37}
                                                            />
                                                        :
                                                        <Image
                                                            alt={`Imagem rede social ${v.rede}`}
                                                            src={v.icon}
                                                            height={30}
                                                            width={30}
                                                        />}
                                                    </a>
                                                );
                                            }
                                            return null;
                                        }
                                        return null;
                                    })}
                                </div>
                            </div>
                            </>
                        }
                        {/* 22/10 (rodada 2): idioma NA BARRA das páginas internas dos topos legados, ao lado do ☰
                            (a linha da gaveta saiu; no celular ele vem antes deste grupo, acima) — só com a opção do CRM */}
                        {temSeletorIdiomas(site) ? (
                            <IdiomaNavItem pilula ocultarAte={768} estilo={{ color: corIconeMenu(site, cor_texto), marginRight: 10 }} />
                        ) : null}
                        <div className={styles.options_header_welcome}>
                            <div
                                className={styles.icon_drawer}
                                onClick={openDrawer}
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    height="1.75rem"
                                    width="1.75rem"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    style={{color: corIconeMenu(site, cor_texto)}}
                                >
                                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                                    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    );
};

export default WelcomePiecesProperties2;

export const getServerSideProps = async () => ({ notFound: true });
